import { IDivergence } from "src/@types/divergence";

export function calculateTotalDivergences(
  divergences: IDivergence[] | undefined,
  reproved_ids?: number[]
) {
  return (
    divergences?.reduce((total, item) => {
      const { amount: amountStr, id } = item;

      if (reproved_ids?.includes(Number(id))) return total;

      const amount = !Number.isNaN(Number(amountStr)) ? Number(amountStr) : 0;

      return total + amount;
    }, 0) ?? 0
  );
}
